/* @flow */

import UnderlyingDataAction from "./UnderlyingDataAction";
import UnderlyingRecordsAction from "./UnderlyingRecordsAction";
import XRayCard from "./XRayCard";
import CompareWithTable from "./CompareWithTable";

export const DEFAULT_ACTIONS = [
  UnderlyingDataAction,
  UnderlyingRecordsAction,
  XRayCard,
  CompareWithTable,
];



// WEBPACK FOOTER //
// ./qb/components/actions/index.js